<template>
  <b-modal
    centered
    id="change-price-per-kv"
    cancel-variant="outline-secondary"
    :ok-title="$t('userManagement.change')"
    :cancel-title="$t('userManagement.cancel')"
    :title="$t('change_price_per_kv')"
    class="add_component_modal"
    @show="onModalOpen"
    @ok.prevent="updatePrice"
  >
    <b-form-group :label="$t('objects.price_per_m')">
      <b-input-group append="UZS">
        <Cleave
          class="form-control"
          v-model="flat.price_per_kv"
          :raw="true"
          :options="options"
        />
      </b-input-group>
    </b-form-group>
    <div class="row">
      <div class="col-6">
        <b-form-group :label="$t('objects.monthly_payment')">
          <b-input-group append="UZS">
            <Cleave
              class="form-control"
              v-model="flat.monthly_payment"
              :raw="true"
              :options="options"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-6">
        <b-form-group :label="$t('objects.number_of_monthly_payment')">
          <b-input-group>
            <b-form-input v-model="flat.number_of_months_payment" />
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group :label="$t('objects.initial_payment_amount')">
          <b-input-group append="UZS">
            <Cleave
              class="form-control"
              v-model="flat.initial_payment_sum"
              :raw="true"
              :options="options"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group :label="$t('objects.initial_percent')">
          <b-input-group append="%">
            <b-form-input v-model="flat.initial_payment_percent" />
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group :label="$t('objects.sale_price')">
          <b-input-group append="UZS">
            <Cleave
              class="form-control"
              v-model="flat.discount_sum"
              :raw="true"
              :options="options"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group :label="$t('objects.sale_percent')">
          <b-input-group append="%">
            <b-form-input v-model="flat.discount_percent" />
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form-group :label="$t('objects.season_price')">
          <b-input-group append="UZS">
            <Cleave
              class="form-control"
              v-model="flat.season_price"
              :raw="true"
              :options="options"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col">
        <b-form-group :label="$t('objects.month_count')">
          <b-input-group append="%">
            <b-form-input v-model="flat.month_count" />
          </b-input-group>
        </b-form-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Cleave from 'vue-cleave-component'
import {
  BModal,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BInputGroup,
} from 'bootstrap-vue'
export default {
  name: 'ChangePricePerKv',

  components: {
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    Cleave,
  },

  props: {
    price: {
      type: Number,
      default: null,
    },
    flatId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      flat: {
        id: null,
        price_per_kv: null,
        initial_payment_sum: null,
        initial_payment_percent: null,
        discount_sum: null,
        discount_percent: null,
        monthly_payment: null,
        number_of_months_payment: null,
        season_price: null,
        month_count: null,
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
    }
  },

  computed: {
    ...mapGetters('', []),
  },

  methods: {
    ...mapActions('flats', ['UPDATE_FLAT_PRICE_PER_SQUARE']),

    formatPrice() {
      const value = this.flat.price_per_kv
        .toString()
        .replace(/[^\d,]/g, '') // Remove all characters except numbers and commas
        .replace(/,/g, '.') // Replace commas with dots to normalize decimal input

      // Convert to a number and format
      const numberValue = parseFloat(value.replace(/\s+/g, ''))
      if (!isNaN(numberValue)) {
        this.flat.price_per_kv = new Intl.NumberFormat('ru-RU', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(numberValue)
      } else {
        this.flat.price_per_kv = ''
      }
    },

    async updatePrice() {
      try {
        if (
          !this.flat.price_per_kv &&
          !this.flat.monthly_payment &&
          !this.flat.number_of_months_payment &&
          !this.flat.initial_payment_sum &&
          !this.flat.initial_payment_percent &&
          !this.flat.discount_sum &&
          !this.flat.discount_percent &&
          !this.flat.season_price &&
          !this.flat.month_count
        )
          return

        await this.UPDATE_FLAT_PRICE_PER_SQUARE(this.flat)
        this.$bvModal.hide('change-price-per-kv')
        this.$emit('updatePrice', Number(this.flat.price_per_kv))
      } catch (error) {
        this.$_errorToast(
          error.response?.data?.message || error.message || 'error'
        )
      }
    },

    onModalOpen() {
      this.$nextTick(() => {
        this.flat.id = this.flatId
        this.flat.price_per_kv = this.price
      })
    },
  },
}
</script>
